import { useQuery } from '@tanstack/react-query';
import { getAllAssistantsApi } from '../utils/apis';

export const useAgents = () => {
  const { data, isLoading, error, isPending, isError } = useQuery({
    queryKey: ['agents'],
    queryFn: async () => {
      const response = await getAllAssistantsApi();
      const storedAgent = localStorage.getItem('selectedAgent');

      if (storedAgent) {
        const parsedStoredAgent = JSON.parse(storedAgent);
        const agentExists = response.data.agents.some(
          (agent: any) => agent._id === parsedStoredAgent._id
        );

        // Remove stored agent if it doesn't exist in current user's agents
        if (!agentExists) {
          localStorage.removeItem('selectedAgent');
        }
      }

      return response;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return {
    agents: data?.data,
    isLoading: isLoading || isPending,
    error,
    isError,
  };
};
